import Divider from '@mui/material/Divider';

export default () => <Divider sx={{ backgroundColor: 'rgba(255, 255, 255, 0.2)' }} />;
